import { ref, computed } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'
import useFormAlert from '@/composables/useFormAlert'

function extractError(err) {
  const data = err.response != null ? err.response.data : null
  return data != null && data.message != null
    ? data.message
    : 'A server error occurred. Please try again later.'
}

export default function useAutoGenerateProgram() {
  const generating = ref(false)
  const approving = ref(false)

  const busy = computed(() => generating.value || approving.value)

  const alert = useFormAlert()

  async function saveColor(draftId, color) {
    try {
      const res = await draftApi.setProgramColor(draftId, color)
      alert.showSuccess(res.data.message)
    } catch (err) {
      alert.showError(extractError(err))
    }
  }

  async function generate(draftId) {
    generating.value = true
    const win = window.open('', '_blank')
    win.document.write('<p style="font-family:sans-serif;padding:2rem">Generating program, please wait…</p>')
    try {
      const res = await draftApi.generateProgram(draftId)
      const url = res.data.data.url
      win.location.href = url
      alert.showSuccess(res.data.message)
      return url
    } catch (err) {
      win.close()
      alert.showError(extractError(err))
      return null
    } finally {
      generating.value = false
    }
  }

  async function approve(draftId) {
    approving.value = true
    try {
      const res = await draftApi.approveProgram(draftId)
      alert.showSuccess(res.data.message)
      return true
    } catch (err) {
      alert.showError(extractError(err))
      return false
    } finally {
      approving.value = false
    }
  }

  return { generating, approving, busy, alert, saveColor, generate, approve }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useAutoGenerateProgram.js